import React, { ComponentProps } from "react";

import { truthy } from "@examspark/common";
import {
  Button,
  ButtonMenu,
  Menu,
  MenuButtons,
  MenuItem,
} from "@examspark/common-ui";
import { IconMoreLine } from "@examspark/common-ui/dist/components/icons";

import { useModal } from "../hooks/useModal";

type Props = {
  buttons: Array<
    | ({
        key: React.Key;
      } & ComponentProps<typeof MenuItem>)
    | undefined
    | false
  >;
};

const PageMenu = ({ buttons }: Props) => {
  const menu = useModal();
  const actualButtons = buttons.filter(truthy);

  // hide the page menu if there are no buttons to show
  if (!actualButtons.length) return null;

  return (
    <>
      <ButtonMenu
        placement="bottom-end"
        button={
          <Button
            variant="outlined"
            icon={<IconMoreLine />}
            title="more options"
          />
        }
        expanded={menu.isOpen}
        onExpandedChange={menu.setIsOpen}
      >
        <Menu>
          <MenuButtons>
            {actualButtons.map(({ key, children, ...props }) => (
              <MenuItem key={key} {...props}>
                {children ?? props.title}
              </MenuItem>
            ))}
          </MenuButtons>
        </Menu>
      </ButtonMenu>
    </>
  );
};

export default PageMenu;
